import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/40",
        action_default:
          "text-primary shadow-sm hover:bg-primary/20 active:bg-primary/30 active:shadow-lg",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        action_muted:
          "text-gray-500 shadow-sm hover:bg-muted-foreground/20 active:bg-muted-foreground/30 active:shadow-lg",
        action_success:
          "text-muted-foreground shadow-sm hover:bg-muted-foreground/20 active:bg-muted-foreground/30 active:shadow-lg",
        action_destructive:
          "text-destructive shadow-sm hover:bg-destructive/20 active:bg-destructive/30 active:shadow-lg",
        border_outline:
          "border border-2 border-primary bg-white font-bold text-primary shadow-sm hover:bg-opacity-50",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        header: "hover:bg-accent hover:text-accent-foreground rounded-lg",
        menu: "bg-primary text-primary-foreground shadow",
        menu_accent: "bg-accent text-accent-foreground shadow",
        light: "bg-accent hover:bg-accent hover:text-accent-foreground w-full border-l border-gray-300",
        collapse: "flex item-center justify-center hover:bg-accent text-white hover:text-gray-500",
        link: "text-primary",
        nav_btn: "bg-accent text-primary shadow-sm hover:bg-white active:bg-white/30 active:shadow-lg",
        // link: "text-primary underline-offset-4 hover:underline p-0",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-8",
        icon: "h-9 w-9",
        iconsm: "h-5 w-5",
        long: "h-20 px-4"
      },
      rounded:{
        default: "rounded-md",
        sm: "rounded-sm",
        none: "rounded-none",
        full: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      rounded: "default"
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, rounded, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    (<Comp
      type="button"
      className={cn(buttonVariants({ variant, size, rounded, className }))}
      ref={ref}
      {...props} />)
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
